import { connect } from 'react-redux';
import { useField } from 'react-final-form';

import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { TextareaField } from 'UIPackage/MainModule/components/TextareaField';
import { UploadFile } from 'UIPackage/MainModule/components/UploadFile';
import { useKnmDocumentAttachment } from 'KnmPackage/MainModule/hooks/useKnmDocumentAttachment';
import { IKnmFormAttachment } from 'KnmPackage/MainModule/interfaces/IKnmFormAttachment';
import { Row } from 'UIPackage/FormModule/components/Row';
import { SelectInputField } from 'UIPackage/MainModule/components/SelectInputField';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { IDictionaryPositionSelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionaryPositionSelectOption';
import { IDictionaryParticipantPositionSelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionaryParticipantPositionSelectOption';
import { getKnmErknmPositionsSelectOptions } from 'KnmPackage/MainModule/selectors/knmSelectors';
import { getDecisionParticipantPositionsSelectOptions } from 'DecisionPackage/MainModule/selectors/decisionSelectors';
import { TextInputField } from 'UIPackage/MainModule/components/TextInputField';

import styles from './KnmActAdditional.module.scss';

interface IErknmActAdditionalProps {
  name: string;
  isDecision?: boolean;
  isPm?: boolean;
  attachment?: IKnmFormAttachment;
}

interface IErknmActAdditionalStoreProps {
  positionsSelectOptions: IDictionaryPositionSelectOption[] | IDictionaryParticipantPositionSelectOption[] | undefined;
  decisionPositionsSelectOptions:
    | IDictionaryPositionSelectOption[]
    | IDictionaryParticipantPositionSelectOption[]
    | undefined;
}

const ErknmActAdditionalWithoutStore = ({
  name,
  isDecision,
  isPm,
  attachment,
  positionsSelectOptions,
  decisionPositionsSelectOptions,
}: IErknmActAdditionalProps & IErknmActAdditionalStoreProps) => {
  const resultContentPositionCancel = useField(`${name}.resultContentPositionCancel`).input.value;

  const { downloadKnmDocumentAttachment } = useKnmDocumentAttachment();

  const downloadAttachment = () => {
    if (!attachment) return null;

    const { fileName, fileSize } = attachment;
    const filePath = attachment.filePath || null;
    const mimeType = attachment.mimeType || null;

    downloadKnmDocumentAttachment({ fileName, filePath, fileSize, mimeType });
  };

  return (
    <>
      <FieldBlock
        label={`Сведения о признании недействительными результатов ${isPm ? 'ПМ' : `КНМ${isDecision ? ', СР' : ''}`}`}
        className={styles.GroupMarginBottom}
      >
        <>
          {attachment && (
            <FieldBlock
              label={'Файл'}
              color="black"
              placementLabel="left"
              type="not-space"
              className={styles.FieldBlock}
            >
              <UploadFile
                fileName={attachment?.fileName || ''}
                fileSize={attachment?.fileSize || 0}
                onFileNameClick={downloadAttachment}
              />
            </FieldBlock>
          )}
          <FieldBlock label={'Комментарий'} placementLabel="left" color="black" className={styles.FieldBlock}>
            <TextareaField
              name={`${name}.noteInvalidate`}
              disabled={true}
              placeholder={'Информация об отмене результатов мероприятия'}
            />
          </FieldBlock>
          <Row>
            <FieldBlock label="ФИО должностного лица" color="black" size="half">
              <TextInputField id="officialFullNameCancel" name={`${name}.officialFullNameCancel`} disabled={true} />
            </FieldBlock>
            <FieldBlock label="Должность лица, отменившего результат" color="black" size="half">
              <SelectInputField
                className={styles.PositionField}
                placeholder="Выберите должность"
                options={isDecision ? decisionPositionsSelectOptions : positionsSelectOptions}
                name={`${name}.resultContentPositionCancel`}
                isSearchable
                size="medium"
                disabled={!!resultContentPositionCancel}
              />
            </FieldBlock>
          </Row>
        </>
      </FieldBlock>
    </>
  );
};

const mapStateToProps = (state: IRootState): IErknmActAdditionalStoreProps => ({
  positionsSelectOptions: getKnmErknmPositionsSelectOptions(state),
  decisionPositionsSelectOptions: getDecisionParticipantPositionsSelectOptions(state),
});

export const KnmActAdditional = connect(mapStateToProps)(ErknmActAdditionalWithoutStore);
